"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Markets = void 0;
const Markets = exports.Markets = {
  'es-AR': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Argentina',
    language: 'Español',
    currency: 'ARS'
  },
  'en-AU': {
    subDomain: 'www',
    languagePath: 'en-au',
    country: 'Australia',
    language: 'English',
    currency: 'AUD'
  },
  'nl-BE': {
    subDomain: 'www',
    languagePath: 'nl',
    country: 'Belgium',
    language: 'Nederlands',
    currency: 'EUR'
  },
  'fr-BE': {
    subDomain: 'www',
    languagePath: 'fr',
    country: 'Belgium',
    language: 'Français',
    currency: 'EUR'
  },
  'pt-BR': {
    subDomain: 'www',
    languagePath: 'pt-br',
    country: 'Brazil',
    language: 'Português',
    currency: 'BRL',
    priceRegex: 'R\\$\\s?\\d+([.,]\\d+)+'
  },
  'en-CA': {
    subDomain: 'www',
    languagePath: 'en-ca',
    country: 'Canada',
    language: 'English',
    currency: 'CAD'
  },
  'fr-CA': {
    subDomain: 'www',
    languagePath: 'fr-ca',
    country: 'Canada',
    language: 'Français',
    currency: 'CAD'
  },
  'es-CL': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Chile',
    language: 'Español',
    currency: 'CLP'
  },
  'es-CO': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Colombia',
    language: 'Español',
    currency: 'COP'
  },
  'da-DK': {
    subDomain: 'dk',
    country: 'Danmark',
    language: 'Dansk',
    currency: 'DKK'
  },
  'de-DE': {
    subDomain: 'www',
    languagePath: 'de',
    country: 'German',
    language: 'Deutsch',
    currency: 'EUR'
  },
  'es-ES': {
    subDomain: 'www',
    languagePath: 'es-es',
    country: 'Spain',
    language: 'Español',
    currency: 'EUR'
  },
  'es-US': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'United States',
    language: 'Español',
    currency: 'USD'
  },
  'fr-FR': {
    subDomain: 'www',
    languagePath: 'fr',
    country: 'France',
    language: 'Français',
    currency: 'EUR'
  },
  'en-HK': {
    subDomain: 'www',
    languagePath: 'en-ie',
    country: 'Hong Kong',
    language: 'English',
    currency: 'HKD'
  },
  'en-IN': {
    subDomain: 'www',
    languagePath: 'en-in',
    country: 'India',
    language: 'English',
    currency: 'INR',
    priceRegex: '₹\\s?\\d+([.,]\\d+)+'
  },
  'hi-IN': {
    subDomain: 'www',
    languagePath: 'hi-in',
    country: 'India',
    language: 'हिंदी',
    currency: 'INR'
  },
  'id-ID': {
    subDomain: 'www',
    languagePath: 'id-id',
    country: 'Indonesia',
    language: 'Bahasa Indonesia',
    currency: 'IDR'
  },
  'en-IE': {
    subDomain: 'www',
    languagePath: 'en-ie',
    country: 'Ireland',
    language: 'English',
    currency: 'EUR'
  },
  'en-IL': {
    subDomain: 'www',
    languagePath: 'en-il',
    country: 'Israel',
    language: 'English',
    currency: 'ILS'
  },
  'it-IT': {
    subDomain: 'www',
    languagePath: 'it',
    country: 'Italia',
    language: 'Italiano',
    currency: 'EUR'
  },
  'en-MY': {
    subDomain: 'www',
    languagePath: 'en-ph',
    country: 'Malaysia',
    language: 'English',
    currency: 'MYR'
  },
  'es-MX': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Mexico',
    language: 'Español',
    currency: 'MXN'
  },
  'nl-NL': {
    subDomain: 'www',
    languagePath: 'nl',
    country: 'Nederland',
    language: 'Nederlands',
    currency: 'EUR'
  },
  'en-NZ': {
    subDomain: 'www',
    languagePath: 'en-ie',
    country: 'New Zealand',
    language: 'English',
    currency: 'NZD'
  },
  'nb-NO': {
    subDomain: 'no',
    country: 'Norway',
    language: 'Bokmål',
    currency: 'NOK'
  },
  'de-AT': {
    subDomain: 'www',
    languagePath: 'de',
    country: 'Austria',
    language: 'Deutsch',
    currency: 'EUR'
  },
  'en-PK': {
    subDomain: 'www',
    languagePath: 'en-ph',
    country: 'Pakistan',
    language: 'English',
    currency: 'PKR'
  },
  'es-PE': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Peru',
    language: 'Español',
    currency: 'PEN'
  },
  'en-PH': {
    subDomain: 'www',
    languagePath: 'en-ph',
    country: 'Philippines',
    language: 'English',
    currency: 'PHP'
  },
  'pl-PL': {
    subDomain: 'www',
    languagePath: 'pl-pl',
    country: 'Poland',
    language: 'Polski',
    currency: 'PLN'
  },
  'pt-PT': {
    subDomain: 'www',
    languagePath: 'pt-pt',
    country: 'Portugal',
    language: 'Português',
    currency: 'EUR'
  },
  'de-CH': {
    subDomain: 'www',
    languagePath: 'de',
    country: 'Switzerland',
    language: 'Deutsch',
    currency: 'CHF'
  },
  'en-SG': {
    subDomain: 'www',
    languagePath: 'en-sg',
    country: 'Singapore',
    language: 'English',
    currency: 'SGD'
  },
  'en-ZA': {
    subDomain: 'www',
    languagePath: 'en-ph',
    country: 'South Africa',
    language: 'English',
    currency: 'ZAR'
  },
  'fr-CH': {
    subDomain: 'www',
    languagePath: 'fr',
    country: 'Switzerland',
    language: 'Français',
    currency: 'CHF'
  },
  'fi-FI': {
    subDomain: 'www',
    languagePath: 'en-ie',
    country: 'Finland',
    language: 'Suomi',
    currency: 'EUR'
  },
  'sv-SE': {
    subDomain: 'se',
    country: 'Sweden',
    language: 'Svenska',
    currency: 'SEK'
  },
  'it-CH': {
    subDomain: 'www',
    languagePath: 'it',
    country: 'Switzerland',
    language: 'Italiano',
    currency: 'CHF'
  },
  'tr-TR': {
    subDomain: 'www',
    languagePath: 'tr-tr',
    country: 'Turkey',
    language: 'Türkçe',
    currency: 'TRY'
  },
  'en-AE': {
    subDomain: 'ae',
    country: 'United Arab Emirates',
    language: 'English',
    currency: 'AED'
  },
  'en-GB': {
    subDomain: 'www',
    languagePath: 'en-uk',
    country: 'United Kingdom',
    language: 'English',
    currency: 'GBP'
  },
  'en-US': {
    subDomain: 'www',
    country: 'United States',
    language: 'English',
    currency: 'USD',
    priceRegex: '\\$\\d+([.,]\\d+)+'
  },
  'es-VE': {
    subDomain: 'www',
    languagePath: 'es',
    country: 'Venezuela',
    language: 'Español',
    currency: 'USD'
  },
  'vi-VN': {
    subDomain: 'www',
    languagePath: 'vi-vn',
    country: 'Vietnam',
    language: 'Tiếng Việt',
    currency: 'VND'
  },
  'el-GR': {
    subDomain: 'www',
    languagePath: 'en-ie',
    country: 'Greece',
    language: 'Ελληνικά',
    currency: 'EUR'
  },
  'ru-RU': {
    subDomain: 'ru',
    country: 'Russia',
    language: 'Русский',
    currency: 'RUB'
  },
  'uk-UA': {
    subDomain: 'www',
    languagePath: 'uk-ua',
    country: 'Ukraine',
    language: 'Українська',
    currency: 'UAH'
  },
  'ar-AE': {
    subDomain: 'ae',
    languagePath: 'ar',
    country: 'United Arab Emirates',
    language: 'Arabic',
    currency: 'AED'
  },
  'th-TH': {
    subDomain: 'www',
    languagePath: 'th-th',
    country: 'Thailand',
    language: 'ไทย',
    currency: 'THB'
  },
  'ko-KR': {
    subDomain: 'kr',
    country: 'Korea',
    language: '한국어',
    currency: 'KRW'
  },
  'zh-TW': {
    subDomain: 'tw',
    country: 'Taiwan',
    language: '繁體中文',
    currency: 'TWD'
  },
  'zh-SG': {
    subDomain: 'www',
    languagePath: 'zh-sg',
    country: 'Singapore',
    language: '简体中文',
    currency: 'CNY',
    priceRegex: '¥\\s?\\d+([.,]\\d+)+'
  },
  'ja-JP': {
    subDomain: 'jp',
    country: 'Japan',
    language: '日本語',
    currency: 'JPY'
  },
  'zh-HK': {
    subDomain: 'hk',
    country: 'Hong Kong',
    language: '繁體中文',
    currency: 'HKD'
  }
};